import React, { useEffect, useState } from "react";
import Nav from "../Nav";
import Footer from "../Footer";

interface Props{
    children:React.ReactNode
}

export default function Layout({children}:Props) {

    const [blackHeader,setBlackHeader] = useState(false)
    useEffect(()=>{
        const scrollListener = () => {
          if(window.scrollY > 60){
            setBlackHeader(true);
          }else{setBlackHeader(false)
          }
        }
    
        window.addEventListener('scroll',scrollListener);
    
        return () => {
          window.removeEventListener('scroll',scrollListener)
        }
      },[]);

  return(
    <div>
        <Nav black={blackHeader}/>
        {children}
        <Footer/>
    </div>
  )
}
